import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useOuvidoriaNavegacao = () => {
  const history = useHistory();

  const handleRowClick = useCallback(
    row => {
      history.push(`/pages/ouvidoria/${row.id}`);
    },
    [history]
  );

  const handleAdicionar = useCallback(() => {
    history.push('/pages/ouvidoria/criar');
  }, [history]);

  const handleEditar = useCallback(
    id => {
      history.push(`/pages/ouvidoria/editar/${id}`);
    },
    [history]
  );

  return {
    handleRowClick,
    handleAdicionar,
    handleEditar,
  };
};
